<div [class.hidden]="!isloading" class="rdo-overlay" style="padding-top: 5%;">
  <img id="overlayImageCG" #overlayImage src="/assets/images/loader-sm.gif" width="20" height="20" />
</div>
<div id="rdo-grid">
  @if (jobs) {
    <rdo-grid-table-ng #cggrid [name]="gridName" [gridConfig]="gridConfig" [pagedData]="jobs"
      [(paging)]="paging" [sorting]="sorting" (pageOnChange)="changePage($event)"
      (lazyLoadOnChange)="changeLazyLoad($event)" [totalCount]="totalCount" [frozenWidth]="'100%'"
      [showColumnSelector]="false" [alwaysShowPager]="false" [fixedScrollableHeight]="'12vh'">
    </rdo-grid-table-ng>
  }
</div>
